/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function GreenFlag({ width = 16, height = 23, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 23"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_967_483)">
        <path
          d="M1.16518 1.16525C1.732 1.44896 2.29951 1.73198 2.86633 2.01707C7.20464 4.1991 11.5436 6.38182 15.8819 8.56454C15.9176 8.58249 15.9526 8.60044 16 8.62391C15.9663 8.64323 15.9416 8.65842 15.9163 8.67154C11.0166 11.1359 6.11766 13.6003 1.21802 16.0639C1.19537 16.0757 1.17067 16.0833 1.14665 16.0922C1.10754 16.0805 1.10822 16.0467 1.10548 16.0156C1.10205 15.9728 1.10342 15.9293 1.10342 15.8865C1.10342 11.0468 1.10342 6.20787 1.10342 1.3682C1.10342 1.32195 1.10205 1.27639 1.10617 1.23014C1.1096 1.19493 1.11714 1.15973 1.16587 1.16525H1.16518Z"
          fill="#54DC00"
        />
        <path
          d="M1.16521 1.1652C1.13364 1.21836 1.14599 1.27772 1.14599 1.33364C1.14599 5.55756 1.14599 9.78149 1.14599 14.0054C1.14599 14.7005 1.14599 15.3964 1.14599 16.0915C1.14599 16.0963 1.14599 16.1005 1.14394 16.1046C1.11855 16.1412 1.08012 16.1481 1.03963 16.1481C0.727397 16.1488 0.414479 16.1502 0.102247 16.1481C0.0651913 16.1481 0.027449 16.1467 0.00480357 16.1087C0.0027449 16.0742 0 16.0404 0 16.0059C0 11.0937 0 6.18159 0 1.27013C0 1.23009 0.00411734 1.19005 0.00617602 1.15002C0.0240178 1.11343 0.058329 1.10929 0.0926402 1.10929C0.411048 1.10584 0.729456 1.10653 1.04718 1.1086C1.08561 1.1086 1.11855 1.11964 1.14531 1.14795C1.15217 1.15416 1.15835 1.15968 1.16521 1.16589V1.1652Z"
          fill="#449612"
        />
        <path
          d="M0.0054618 16.1081C0.384944 16.1067 0.765112 16.106 1.14459 16.1046C1.14459 16.2454 1.14597 16.3863 1.14597 16.5271C1.14597 18.6421 1.14597 20.7579 1.14597 22.873C1.14597 22.9572 1.10365 22.9993 1.01901 22.9993C0.72188 22.9993 0.424745 22.9993 0.12761 22.9993C0.00408936 22.9993 0.00408936 22.9993 0.00408936 22.8764C0.00408936 21.6608 0.00408936 20.4452 0.00408936 19.2289C0.00408936 18.1886 0.00477558 17.1483 0.0054618 16.1074V16.1081Z"
          fill="#465B65"
        />
        <path
          d="M1.1463 1.14727C0.766821 1.14796 0.386653 1.14865 0.00717133 1.15003C0.00648511 0.794532 0.00648511 0.438339 0.00374021 0.0828356C0.00305399 0.0248507 0.0229545 0 0.082656 0C0.410671 0.00207089 0.739372 0.00207089 1.06739 0C1.13326 0 1.14768 0.0283022 1.14768 0.088358C1.14562 0.4411 1.1463 0.794532 1.1463 1.14727Z"
          fill="#465B65"
        />
      </g>
      <defs>
        <clipPath id="clip0_967_483">
          <rect width="16" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default GreenFlag;
